import { jsx as _jsx } from "react/jsx-runtime";
import translate from "../../../i18n/translate";
export default function Loader() {
    return (_jsx("div", { className: "loader -fullscreen", children: _jsx("div", { className: "content content-loader", children: translate("app.loading") }) }));
}
